var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-section"},[_c('StringEntry',{attrs:{"value":_vm.value.name,"name":"name","label":"Nazwa"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }